module.exports = __webpack_public_path__ + "assets/img/store-reg-banner-03.ba5bb03c.png";